import ErrorMessageComponent from './error-message.component'

const ErrorMessageModule = angular.module('cdbl.error-message', [

])
  .component('cdblErrorMessage', ErrorMessageComponent)
  .name

export default ErrorMessageModule
